import classNames from "classnames";
import Button from "components/Button";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { AddAgent } from "helpers/api";
import "react-toastify/dist/ReactToastify.css";

const NewAgent = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      email: yup.string().trim().required("Ce champ est requis"),
      password: yup.string().trim().required("Ce champ est requis"),
    }),

    onSubmit: (values) => {
      AddAgent({
        email: values.email,
        password: values.password,
      })
        .then((response) => {
          toast("Agent ajouté avec succèe", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "success",
          });
          formik.resetForm();
        })
        .catch((err) => {
          toast("Erreur", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "error",
          });
        });
    },
  });

  return (
    <div className="flex flex-col mx-[30px] my-[30px] min-h-full w-full justify-center">
      <div className="text-[#5d55e8] text-[18px] h-[27px] mt-[150px] mb-20 font-bold   flex items-center justify-center rounded mx-auto ">
        Ajoutez nouveau agent
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="w-full flex flex-col items-center gap-12 my-8"
      >
        <div className="flex gap-2  items-center justify-between ">
          <span className="font-semibold text-[20px] w-[200px] text-left ">
            Email :
          </span>
          <input
            placeholder="email"
            autoComplete="off"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            id="email"
            name="email"
            value={formik.values.email}
            className={classNames(
              "mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4  w-[300px] h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light"
            )}
          />
        </div>

        <div className="flex  gap-2 items-center">
          <span className="font-semibold text-[20px] w-[200px]  text-left ">
            Mot de passe :
          </span>
          <input
            placeholder="Mot de passe"
            autoComplete="off"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            id="password"
            name="password"
            value={formik.values.password}
            className={classNames(
              "  mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4  w-[300px] h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light"
            )}
          />
        </div>

        <div className="  flex flex-col gap-4 mt-[50px]  ">
          <Button type="submit" variant="primary">
            <div className="flex items-center justify-center gap-10  w-full  ">
              <div className="text-sm font-bold text-white text-[18px]">
                Créez
              </div>
            </div>
          </Button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
};

export default NewAgent;
